import { render, staticRenderFns } from "./ArchivedOrders.vue?vue&type=template&id=5f556f3a&"
import script from "./ArchivedOrders.vue?vue&type=script&lang=js&"
export * from "./ArchivedOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports